export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-white py-24 md:py-32 px-4">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-16 items-center">

        {/* Left: Text */}
        <div className="flex-1 lg:w-[60%]">
          <p className="text-teal-600 text-xs font-bold tracking-widest uppercase mb-4 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-teal-500 inline-block" />
            About the Directory
          </p>
          <h2 className="font-serif text-4xl md:text-5xl text-slate-800 leading-tight mb-8">
            Premium Rentals on<br />
            Louisiana's Hidden Gem —<br />
            <span className="text-teal-600">6,400 Pristine Acres</span>
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed mb-6">
            Nestled in the rolling piney hills of north Louisiana, Lake Claiborne is one of the state's most beloved and unspoiled freshwater lakes. Spanning over 6,400 acres near the charming town of Homer, this reservoir offers a rare blend of natural serenity and outdoor adventure that's hard to find anywhere else in the South.
          </p>
          <p className="text-slate-600 text-lg leading-relaxed mb-8">
            LakeClaiborneRentals.com is launching soon as the go-to directory for short-term rental properties on Lake Claiborne — cabins, cottages, and waterfront homes all showcased in one place. Whether you're casting a line for trophy bass, kayaking through glassy morning waters, or simply unwinding on a private dock as the sun melts into the horizon, we'll help you find the perfect property for your stay.
          </p>
          <div className="flex flex-wrap gap-4">
            {['Fishing', 'Kayaking', 'Swimming', 'Boating', 'Hiking', 'Wildlife'].map((tag) => (
              <span
                key={tag}
                className="bg-teal-50 text-teal-700 text-sm font-medium px-4 py-1.5 rounded-full border border-teal-100"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* Right: Images */}
        <div className="flex-1 lg:w-[40%] flex flex-col gap-4">
          <div className="w-full h-64 md:h-72 rounded-2xl overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/dc6515c8820bb07c987b5962f1964caa.jpg"
              alt="Lake Claiborne sunset"
              className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
            />
          </div>
          <div className="flex gap-4">
            <div className="flex-1 h-44 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=fishing%20boat%20on%20calm%20lake%20at%20dawn%2C%20misty%20morning%20water%2C%20Louisiana%20lake%2C%20peaceful%20serene%20scene%2C%20soft%20golden%20light%2C%20nature%20photography&width=350&height=280&seq=about-lake-boat&orientation=squarish"
                alt="Fishing on Lake Claiborne"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="flex-1 h-44 rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=cozy%20lakefront%20cabin%20rental%20with%20wooden%20deck%20overlooking%20calm%20lake%20water%2C%20pine%20trees%20surrounding%2C%20warm%20inviting%20atmosphere%2C%20vacation%20rental%20property%2C%20soft%20natural%20lighting&width=350&height=280&seq=about-lake-cabin&orientation=squarish"
                alt="Lakefront cabin rental"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
